export default function initOrderOptins(){
    const button = document.getElementById('selectPayment');
    const hasOptins = document.getElementById('has_orderflow_optins') !== null;
    const endpoint = document.getElementById('has_orderflow_optins')?.dataset.endpoint;

    if (!button || !hasOptins || !endpoint) {
        return;
    }

    const updateOptins = () => {
        const checkboxes = document.getElementsByName('orderflow_optins[]');
        const optins = [];
        checkboxes.forEach((element) => {
            if (element.checked) {
                optins.push(element.value);
            }
        });

        fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ optins })
        });
    };

    button.addEventListener('click', updateOptins);
}
